<template>
<div id="lightbox" v-if="mergedOptions.showLightbox || toggleLightbox">
    <div class="overlay"></div>
    <div class="top-nav">
        <div><v-icon name="play-circle" scale="2" v-if="mergedOptions.showIcons.diashow" /></div>
        <div><v-icon name="expand-arrows-alt" scale="2" v-if="mergedOptions.showIcons.fullscreen" /></div>
        <div @click="closeLightbox()"><v-icon name="times" scale="3" v-if="mergedOptions.showIcons.close" /></div>
    </div>
    <div class="images-container">
        <div class="image-box" :style="'width: ' + images[thisCurrentImageIndex].width + 'px; height: ' + images[thisCurrentImageIndex].height + 'px;'">
            <v-icon name="spinner" pulse scale="2" v-if="images[thisCurrentImageIndex].hide"></v-icon>
            <transition name="fade">
                <img class="image" :src="mergedOptions.localPath ? require('@/' + images[thisCurrentImageIndex].url) : images[thisCurrentImageIndex].url" alt="" v-if="!images[thisCurrentImageIndex].hide">
            </transition>
        </div>
        <div class="inner-nav" :style="'height: ' + images[thisCurrentImageIndex].height + 'px;'" v-if="!images[thisCurrentImageIndex].hide">
            <div class="partial-nav left" @click="selectPrevious()">
                <v-icon name="angle-left" scale="4" v-show="thisCurrentImageIndex > 0" v-if="mergedOptions.showIcons.previous"/>
            </div>
            <div class="partial-nav right" @click="selectNext()">
                <v-icon name="angle-right" scale="4" v-show="thisCurrentImageIndex < totalImages - 1" v-if="mergedOptions.showIcons.next" />
            </div>
        </div>
        <div class="text-box">
            <div class="text">
              <span>{{ images[thisCurrentImageIndex].title }}</span>
              <span>{{ images[thisCurrentImageIndex].description }}</span>
            </div>
            <div class="counter">
              <span>{{ 'Image ' + (parseInt(thisCurrentImageIndex) + 1) + '/' +  totalImages }} </span>
            </div>
        </div>
    </div>
</div>

</template>

<script>
export default {
  name: 'VueLightbox',
  props: {
    images: {
      type: Array,
      default: () => ([]),
      required: false
    },
    options: {
      type: Object,
      default: () => ({}),
      required: false
    },
    currentImageIndex: {
      type: Number,
      default: 0
    },
    toggleLightbox: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      thisCurrentImageIndex: 0,
      totalImages: this.images.length,
      compressIconScale: 2,
      mergedOptions: {},
      defaultOptions: {
        showLightbox: false,
        showIcons: {
          diashow: true,
          fullScreen: true,
          close: true,
          next: true,
          previous: true
        },
        localPath: false,
        localPathPrefix: ''
      }
    }
  },
  created () {
    console.log(this.totalImages)
    this.setOptions()
    this.preloadImage(0)
    if (this.images.length > 1) this.preloadImage(1)
    if (this.mergedOptions.showLightbox) document.body.style.overflow = 'hidden'
  },
  methods: {
    setOptions () {
      const d = this.defaultOptions
      const o = this.options
      this.mergedOptions = assignObject(o, d)
      function assignObject (a, b) {
        let m = {}
        Object.keys(b).forEach((key) => {
          if (typeof a[key] === 'object' && a[key] !== null) {
            console.log('>>>>>>', a[key], b[key])
            m[key] = assignObject(a[key], b[key])
          } else if (a[key] && a[key].isArray && a[key].length > 1) {
            m[key] = assignArray(a[key], b[key])
          } else if (typeof a[key] === 'undefined') {
            m[key] = b[key]
          } else {
            m[key] = a[key]
          }
        })
        return m
      }
      function assignArray (a, b) {
        let m = {}
        b.forEach((key, value) => {
          if (typeof a[key] === 'object' && a[key] !== null) {
            m[key] = assignObject(a[key], b[key])
          } else if (a[key] && a[key].isArray && a[key].length > 1) {
            m[key] = assignArray(a[key], b[key])
          } else if (typeof a[key] === 'undefined') {
            m[key] = b[key]
          } else {
            m[key] = a[key]
          }
        })
        return m
      }
    },
    selectPrevious () {
      if (this.thisCurrentImageIndex > 0) {
        // # set hide status if image has different size #
        const i = this.thisCurrentImageIndex
        if (this.images[i].width !== this.images[i - 1].width || this.images[i].height !== this.images[i - 1].height) {
          this.$set(this.images[i - 1], 'hide', true)
          setTimeout(() => {
            this.$set(this.images[i - 1], 'hide', false)
          }, 1500)
        }
        // # set next image index #
        this.thisCurrentImageIndex--
        // # preload next image if some exists #
        const previousImageIndex = this.thisCurrentImageIndex - 1
        if (this.images[previousImageIndex] && !this.images[previousImageIndex].loaded && previousImageIndex > 0) this.preloadImage(previousImageIndex)
      }
    },
    selectNext  () {
      if (this.thisCurrentImageIndex < this.totalImages - 1) {
        // # set hide status if image has different size #
        const i = this.thisCurrentImageIndex
        if (this.images[i].width !== this.images[i + 1].width || this.images[i].height !== this.images[i + 1].height) {
          console.log('SET SCALE', this.thisCurrentImageIndex)
          this.$set(this.images[i + 1], 'hide', true)
          setTimeout(() => {
            this.$set(this.images[i + 1], 'hide', false)
          }, 1500)
        }
        // # set next image index #
        this.thisCurrentImageIndex++
        // # preload next image if some exists #
        const nextImageIndex = this.thisCurrentImageIndex + 1
        if (this.images[nextImageIndex] && !this.images[nextImageIndex].loaded && nextImageIndex < this.totalImages) this.preloadImage(nextImageIndex)
      }
    },
    preloadImage (index) {
      console.log('PRELOAD IMAGE', this.images[index].url)
      const image = new Image()
      let url
      console.log('localpath', this.mergedOptions.localPath, this.mergedOptions.localPathPrefix)
      if (this.mergedOptions.localPath) {
        url = require('@/' + this.images[index].url)
      } else {
        url = this.images[index].url
      }
      console.log('URL', url)
      image.src = url
      image.onload = () => {
        const imgWidth = image.width
        const imgHeight = image.height
        const w = window; const d = document
        const border = 4; const margin = 70
        const windowWidth = w.innerWidth || d.documentElement.clientWidth || d.body.clientWidth
        const windowHeight = w.innerHeight || d.documentElement.clientHeight || d.body.clientHeight
        const maxImageWidth = windowWidth - 2 * border - 2 * margin
        const maxImageHeight = windowHeight - 2 * border - 2 * margin
        let resizedImageWidth, resizedImageHeight

        this.$set(this.images[index], 'width', imgWidth)
        this.$set(this.images[index], 'height', imgHeight)

        console.log('Preload', imgWidth, maxImageWidth, imgHeight, maxImageHeight)
        if ((imgWidth > maxImageWidth) || (imgHeight > maxImageHeight)) {
          if ((imgWidth / maxImageWidth) > (imgHeight / maxImageHeight)) {
            resizedImageWidth = maxImageWidth
            resizedImageHeight = parseInt(imgHeight / (imgWidth / resizedImageWidth), 10)
            image.width = resizedImageWidth
            image.height = resizedImageHeight
            this.$set(this.images[index], 'width', resizedImageWidth)
            this.$set(this.images[index], 'height', resizedImageHeight)
          } else {
            resizedImageHeight = maxImageHeight
            resizedImageWidth = parseInt(imgWidth / (imgHeight / resizedImageHeight), 10)
            image.width = resizedImageWidth
            image.height = resizedImageHeight
            this.$set(this.images[index], 'width', resizedImageWidth)
            this.$set(this.images[index], 'height', resizedImageHeight)
          }
        }
        this.$set(this.images[index], 'loaded', true)
      }
    },
    closeLightbox () {
      this.mergedOptions.showLightbox = false
      this.$emit('toggleLightbox', false)
    }
  },
  watch: {
    currentImageIndex: function (newVal, oldVal) {
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.thisCurrentImageIndex = newVal
    },
    toggleLightbox: function (newVal, oldVal) {
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.toggleLightbox ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'auto'
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active {
  transition: opacity .5s;
}
.fade-leave-active {
  transition: opacity .1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
#lightbox {
  z-index: 100000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .overlay {
        background-color: rgba(0, 0, 0, 0.8);
        width: 100%;
        height: 100%;
        position: absolute;
    }
    .top-nav {
        position: absolute;
        top: 20px;
        right: 0;
        color: #fff;
        display: flex;
        align-items: center;
        .fa-icon {
            margin-right: 20px;
            &:last-child {
                margin-left: 30px;
            }
            cursor: pointer;
        }
    }
    .images-container {
        position: relative;
        display: inline-flex;
        flex-flow: column;
        margin: 49px;
        .image-box {
            -webkit-transform: translateZ(0);
            transition: width 1.5s, height 1.5s;
            border-radius: 3px;
            border: 4px solid white;
            background-color: #fff;
            overflow: hidden;
            .fa-icon.fa-pulse {
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -16px;
                margin-left: -15px;
                color: #bababa;
            }
            .image {
              width: 100%;
            }
        }
        .text-box {
            padding: 5px 4px;
            color: #cccccc;
            display: flex;
            flex-flow: column;
            .text {
              padding-right: 50px;
              display: flex;
              flex-flow: column;
              span:first-child {
                  font-size: 15px;
                  font-weight: bold;
                  line-height: 1em;
              }
              span:last-child {
                  font-size: 14px;
                  color: #999999;
              }
            }
            .counter {
              span {
                font-size: 14px;
                color: #999999;
              }
            }
        }
        .inner-nav {
                cursor: pointer;
                position: absolute;
                top: 0;
                height: 100%;
                width: 100%;
                display: flex;
                .partial-nav {
                    width: 50%;
                    display: flex;
                    align-items: center;
                    .fa-icon {
                        color: white;
                    }
                    &.left {
                        justify-content: flex-start;
                        opacity: 0;
                        transition: opacity 1s;
                        .fa-icon {
                            margin-left: 20px;
                            -webkit-filter: drop-shadow( 3px 0px 2px rgba(0, 0, 0, .7));
                            filter: drop-shadow( 3px 0px 2px rgba(0, 0, 0, .7));
                        }
                        &:hover {
                            opacity: 1;
                        }
                    }
                    &.right {
                        justify-content: flex-end;
                        opacity: 0;
                        transition: opacity 1s;
                        .fa-icon {
                            margin-right: 20px;
                            -webkit-filter: drop-shadow( -3px 0px 2px rgba(0, 0, 0, .7));
                            filter: drop-shadow( -3px 0px 2px rgba(0, 0, 0, .7));
                        }
                        &:hover {
                            opacity: 1;
                        }
                    }

                }
            }
    }
}

</style>
